import { createSelector } from 'reselect'

/**
 * Selects the current menu.
 * @returns {Selector}
 */
function getCurrentMenuSelector () {
  return createSelector(
    state => state && state.menu,
    (menu) => menu.current
  )
}

/**
 * Selects the current menu's data.
 * @returns {Selector}
 */
function getActionMenuSelector () {
  return createSelector(
    state => state && state.menu,
    (menu) => menu.action
  )
}

/**
 * Selects the current menu's data.
 * @returns {Selector}
 */
function getNavigationMenuSelector () {
  return createSelector(
    state => state && state.menu,
    (menu) => menu.navigation
  )
}

export {
  getCurrentMenuSelector,
  getActionMenuSelector,
  getNavigationMenuSelector
}
